<template>
  <div class="preview-live-switch">
    <button
      :title="isPreview ? 'Remove Preview' : 'Show Preview'"
      :class="{'active': isPreview}"
      class="tb-btn-contained margin-left-xxs sample"
      @click.stop="togglePreview"
    >
      <strong class="preview-icon">P</strong>
    </button>

    <button
      :title="isLive ? 'Remove Live' : 'Go Live'"
      :class="{'active': isLive}"
      class="tb-btn-contained margin-left-xxs alarm"
      @click.stop="toggleLive"
    >
      <strong class="live-icon">L</strong>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapState({
      production: (state) => state.production.production,
      preview: (state) => state.preview.production,
    }),

    timelineId() {
      return this.item.timeline_id;
    },

    isLive() {
      return this.production.index === this.timelineId;
    },

    isPreview() {
      return this.preview.index === this.timelineId;
    },
  },

  methods: {
    toggleLive() {
      this.$store.dispatch('toggleLive', { timelineId: this.timelineId });
    },

    togglePreview() {
      this.$store.dispatch('togglePreview', { timelineId: this.timelineId });
    },
  },
};
</script>
